import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'
import classnames from 'classnames'
import get from 'lodash/get'
import { Link } from 'react-router'
import './Players.css'
import { loadPlayer } from '../../actions'
import { fetchData } from '../../decorators'
import { formatMoney } from '../../util'

class Player extends React.Component {
  render() {
    const { playerId, player } = this.props

    if(!player || player.isLoading) {
      return <div>Loading player...</div>
    }

    const profits = get(player, 'stats.profits')

    return (
      <div className="player-wrapper">
        <div className="secondary-menu hbox hbox--hcenter">
            <Link
              to={`/players/${playerId}/bets`}
              className="secondary-menu__item"
              activeClassName="secondary-menu__item--active">
              Bets
            </Link>

            <Link
              to={`/players/${playerId}/tickets`}
              className="secondary-menu__item"
              activeClassName="secondary-menu__item--active">
              Tickets
            </Link>

            <Link
              to={`/players/${playerId}/analytics`}
              className="secondary-menu__item"
              activeClassName="secondary-menu__item--active">
              Analytics
            </Link>

            <Link
              to={`/players/${playerId}/recommendations`}
              className="secondary-menu__item"
              activeClassName="secondary-menu__item--active">
              Recommendations
            </Link>

        </div>

        <div className="info-bar" id="player-info-bar">
          <div className="hbox hbox--hcenter">
            <div className="player-country info-bar__box">
              <h2 className="info-bar__box__title">Country</h2>
              <div>
                <span className="info-bar__box__value">{ player.country } </span>
              </div>
            </div>

            <div className="player-created info-bar__box">
              <h2 className="info-bar__box__title">Created</h2>
              <div>
                <span className="info-bar__box__value">{ moment(player.registration_date).format('YYYY-MM-DD') } </span>
              </div>
            </div>

            <div className="player-last-bet info-bar__box">
              <h2 className="info-bar__box__title">Last bet</h2>
              <div>
                <span className="info-bar__box__value">{ moment(get(player, 'properties.last_bet_date')).format('YYYY-MM-DD') } </span>
              </div>
            </div>

            <div className="player-rating info-bar__box">
              <h2 className="info-bar__box__title">Rating (m/a)</h2>
              <div>
                <span className="info-bar__box__value">{ get(player, 'properties.manual_rating') }/{ get(player, 'properties.automatic_rating') }</span>
              </div>
            </div>

            <div className="player-total-tickets info-bar__box">
              <h2 className="info-bar__box__title">Total Tickets</h2>
              <div className="info-bar__box__value">{ get(player, 'stats.tickets_total') }</div>
            </div>

            <div className="player-stake info-bar__box">
              <h2 className="info-bar__box__title">Stake</h2>
              <div>
                <span className="info-bar__box__value">{ formatMoney(get(player, 'stats.stake_total')) } </span>
                <span className="info-bar__box__subtitle">{ formatMoney(get(player, 'stats.stake_mean')) } avg</span>
              </div>
            </div>

            <div className="player-prize info-bar__box">
              <h2 className="info-bar__box__title">Prize</h2>
              <div>
                <span className="info-bar__box__value">{ formatMoney(get(player, 'stats.prize_total')) } </span>
                <span className="info-bar__box__subtitle">{ formatMoney(get(player, 'stats.prize_mean')) } avg</span>
              </div>
            </div>

            <div className="player-profits info-bar__box">
              <h2 className="info-bar__box__title">Profits</h2>
              <div>
                <span className={classnames("info-bar__box__value", {"info-bar__box__value--negative": (profits < 0)})}>
                  { formatMoney(profits) + ' '}
                </span>
                <span className="info-bar__box__subtitle">
                  {formatMoney(profits / get(player, 'stats.tickets_total'))} avg
                </span>
              </div>
            </div>

            <div className="player-recall info-bar__box">
              <h2 className="info-bar__box__title">top 5 recall</h2>
              <div>
                <span className="info-bar__box__value">
                  { player.recall5 >= 0 ? numeral(player.recall5).format('0.0%') : 'N/A' }
                </span>
              </div>
            </div>

            <div className="player-recall info-bar__box">
              <h2 className="info-bar__box__title">top 10 recall</h2>
              <div>
                <span className="info-bar__box__value">
                  { player.recall10 >= 0 ? numeral(player.recall10).format('0.0%') : 'N/A' }
                </span>
              </div>
            </div>


            <div className="player-bets-since-jan info-bar__box">
              <h2 className="info-bar__box__title">Bets since Jan</h2>
              <div>
                <span className="info-bar__box__value">{ player.bets_since_jan } </span>
              </div>
            </div>
          </div>

          <div className="hbox hbox--hcenter user-id">
            user id: {player.id}
          </div>
        </div>

        { this.props.children }
      </div>
    )
  }
}

const withFetch = fetchData((props, nextProps) => {
  const { playerId, player, loadPlayer } = nextProps
  if(!player || !player.analytics) {
    loadPlayer(playerId)
  }
})(Player)

export default connect(
  (state, ownProps) => ({
    player: state.entities.players[ownProps.params.playerId],
    playerId: ownProps.params.playerId
  }),
  { loadPlayer }
)(withFetch)



// WEBPACK FOOTER //
// ./src/components/Players/Player.js